import { Alert } from "@mui/material";
import * as React from "react";
import { P, H1, Content } from "../recurso_literario.js";

export const ComputoAcciones = () => {
	return(
		<Content>
			<H1> Acciones sobre una VM </H1>
			<P>
				El panel en la parte inferior de la pantalla te presentará las
				acciones que podrás realizar sobre la VM actual
			</P>
			<img src="/img/Computo/VM/acciones.PNG" alt="Acciones de Computo" style={{width:"30%", marginLeft:"40px"}} />
			<P>
				A continuación, se detalla cada acción
			</P>

			<h2> Detener/Encender </h2>
			<P>
				<img src="/img/Computo/VM/acc_prender.png" alt="Prender VM"/>
				<img src="/img/Computo/VM/acc_apagar.png" alt="Apagar VM"/>
			</P>
			<P>
				Permiten detener y encender la VM. El apagado se realiza desde el S.O. por lo cual
				los servicios se irán apagando correctamente. Este botón cambia dependiendo
				del estado de la VM. Si está encendida se presenta el botón de apagado. Si está
				apagada se presenta el botón de encendido.
			</P>

			<h2> Consola </h2>
			<P>
				<img src="/img/Computo/VM/acc_consola.png" alt="Prender o apagar VM"/>
			</P>
			<P>
				Permite acceder a la consola del S.O.
			</P>

			<h2> Reconstruir </h2>
			<P>
				<img src="/img/Computo/VM/acc_restaurar.png" alt="Prender o apagar VM"/>
			</P>
			<P>
				Si deseas de forma fácil regresar la VM al mismo estado en el que estaría
				si estuviese recién desplegada, pero manteniendo su configuración actual,
				esta acción es la indicada.
			</P>

			<P>
				Desde aquí podrás regresar la VM al mismo estado como si se hubiese recién
				desplegado. No  tendrás que indicar nuevamente el hardware virtual, la
				configuración de los puertos de red o volúmenes. Se mantendrán como hasta
				el momento de realizar la reconstrucción. Esto significa que mantendrás las
				mismas IP privadas o Públicas en las interfaces, la cantidad de volúmenes
				con sus dimensiones y velocidades, así como los puntos de montaje.
				El contenido de los volúmenes sin embargo será completamente eliminado.
				los snapshot también serán eliminados ya que dependen de los volúmenes.
			</P>

			<P>
				Al presionar el botón, se te presentará una ventana donde deberás seleccionar
				el S.O. al cual reconstruir la VM. Recuerda que cada S.O. tiene su precio
				asociado. Entonces, si decidís reconstruir tu VM a un S.O. distinto del que
				tenías, comenzarás en ese momento a pagar por hora en base al nuevo S.O. En
				esta pantalla también deberás especificar mínimamente un usuario y contraseña
				inicial para los S.O. Linux.
			</P>

			<Alert severity="error">
				Recordá que él contenido de los volúmenes y los snapshot serán completamente
				eliminados.
			</Alert>

			<h2> Escalar </h2>
			<P>
				<img src="/img/Computo/VM/acc_escalar.png" alt="Escalar VM"/>
			</P>
			<P>
				Permite cambiar la definición de hardware virtual el cual se define por
				la cantidad de VCPU y memoria RAM.
			</P>

			<P>
				Al presionar el botón se te presentará una ventana donde podrás
				seleccionar el hardware virtual al cual deseas actualizar tu VM.
				Se te informará además del valor por hora de la nueva configuración.
			</P>
				
			<Alert>
				Esta acción no ocasiona que la VM se apague o reinicie. Sin embargo,
				dependiendo del S.O. puede que se requiera reiniciar de forma
				explícita para que tome los cambios.
			</Alert>

			<h2> Eliminar </h2>
			<P>
				<img src="/img/Computo/VM/acc_eliminar.png" alt="Eliminar VM"/>
			</P>
			<P>
				Permite eliminar una VM. Se presentará una ventana donde deberás confirmar
				la acción de eliminación. La eliminación de una VM no tiene marcha atrás
				así que deberás estar muy seguro.

				Los snapshot que pudiese tener la VM también serán eliminados.

				La eliminación de la VM no incluye sus volúmenes de datos. Si querés además
				eliminarlos, deberás ir a la sección de volúmenes y eliminarlos desde allí.

				Los puertos de red serán eliminados liberando las IP privadas. Las IP
				Públicas que pudiese tener la VM también serán liberadas, pero no eliminadas.
				Seguirán en tu poder y podrás usarlas para otra VM. Tené en cuenta que si
				tampoco deseas seguir utilizándolas, deberás ir a la sección de IP Públicas 
				y eliminarlas al igual que ocurre con los volúmenes.
			</P>

			<h2> Mover de Proyecto </h2>
			<P>
				<img src="/img/Computo/VM/acc_mover.png" alt="Eliminar VM"/>
			</P>
			<P>
				Permite mover la VM desde el proyecto donde está a otro proyecto. Al mover
				una VM a otro proyecto, también se moverán de proyecto los discos attachados
				a la VM y las IP Públicas de sus interfaces. De igual modo, si movés a otro
				proyecto un disco y ese disco se encuentra attachado a una VM, la VM también
				será movida de proyecto.

				Al presionar el botón, se te presentará una ventana donde deberás indicar el
				proyecto destino y luego confirmar la acción.
			</P>
			<P>
				<img src="/img/Computo/VM/acc_mover2.png" alt="Popup mover" style={{width:"400px", marginLeft:"40px"}}/>
			</P>

		</Content>
	)
}
